import { parseJwt } from "@/models/utils";
import useUser from "@/stores/useUser";
import { StorageKeys, setStorageItem } from "@/services/storages/StorageKeys";

const originSearchParams = new URLSearchParams(location.search);
const token = originSearchParams.get("token");

if (token && location.pathname.startsWith("/person")) {
  try {
    const parsedUser = parseJwt(token);
    const user = {
      user: {
        ...parsedUser,
        access_token: token,
        id: parsedUser.user.id,
        username: parsedUser.user.name,
      },
      fetching: {
        isLoading: false,
        isRefreshing: false,
        refreshRequest: {},
      },
    };

    setStorageItem(StorageKeys.user, JSON.stringify(user));
    useUser.setState(user as any);
  } catch (error) {
    console.error(error);
  }
}
